import React, { useEffect, useState } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import "./SideBar.css";
import Logo from "./Logo";
import SofIcon from "./Icons";
import clsx from "clsx";
import { MdReceipt } from "react-icons/md";

const CustomerSidebar: React.FC = () => {
  const [selectedMenu, setSelectedMenu] = useState("");
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    console.log("LOCATION", history.location)
    const path = location.pathname;
    if (path.includes("marine")) {
      setSelectedMenu("marine");
    } else if (path === "/customer/reports") {
      setSelectedMenu("reports");
    } else if (path === "/customer/signout") {
      setSelectedMenu("profile");
    } else if (path === "/customer/help") {
      setSelectedMenu("help");
    } else if (path === "/customer") {
      setSelectedMenu("dashboard");
    } else if (path.includes("/customer/truck")) {
      setSelectedMenu("truck");
    } else if (path.includes("/customer/tank")) {
      setSelectedMenu("tank");
    } else if (path.includes("/customer/rail")) {
      setSelectedMenu("rail");
    } else if (path.includes("/customer/invoice")) {
      setSelectedMenu("invoice");
    } else if (path.includes("/customer/order")) {
      setSelectedMenu("order");
    }
  }, [location.pathname]);

  return (
    <nav className="sidebar">
      <div>
        <div className="logo-wrapper">
          <NavLink to="/">
            {/* <Logo className="logo" /> */}
            <img
              src="logo-yellow.svg"
              alt="QADWorks"
              style={{ width: 80.25, height: 48 }}
            />
          </NavLink>
        </div>
        <NavLink
          id="nav-dashboard"
          to="/customer"
          className={clsx(
            "sidebar-item",
            selectedMenu === "dashboard" && "sidebar-selected"
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M160-520v-280h280v280H160Zm0 360v-280h280v280H160Zm360-360v-280h280v280H520Zm0 360v-280h280v280H520ZM200-560h200v-200H200v200Zm360 0h200v-200H560v200Zm0 360h200v-200H560v200Zm-360 0h200v-200H200v200Zm360-360Zm0 160Zm-160 0Zm0-160Z" />
          </svg>
          <span>Dashboard</span>
        </NavLink>
        <NavLink
          id="nav-order"
          to="/customer/order"
          className={clsx(
            "sidebar-item",
            selectedMenu === "order" && "sidebar-selected"
          )}
          exact
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 15.6538L15.6538 12L14.6 10.9462L12.75 12.7463V8.34625H11.25V12.7463L9.4 10.9462L8.34625 12L12 15.6538ZM5.30775 20.5C4.80908 20.5 4.38308 20.3234 4.02975 19.9703C3.67658 19.6169 3.5 19.1909 3.5 18.6923V5.30775C3.5 4.80908 3.67658 4.38308 4.02975 4.02975C4.38308 3.67658 4.80908 3.5 5.30775 3.5H9.75775C9.82058 2.94483 10.0629 2.47275 10.4848 2.08375C10.9064 1.69458 11.4115 1.5 12 1.5C12.5948 1.5 13.1032 1.69458 13.525 2.08375C13.9468 2.47275 14.1859 2.94483 14.2423 3.5H18.6923C19.1909 3.5 19.6169 3.67658 19.9703 4.02975C20.3234 4.38308 20.5 4.80908 20.5 5.30775V18.6923C20.5 19.1909 20.3234 19.6169 19.9703 19.9703C19.6169 20.3234 19.1909 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7693 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7693 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19ZM12 4.34625C12.2167 4.34625 12.3958 4.27542 12.5375 4.13375C12.6792 3.99208 12.75 3.81292 12.75 3.59625C12.75 3.37958 12.6792 3.20042 12.5375 3.05875C12.3958 2.91708 12.2167 2.84625 12 2.84625C11.7833 2.84625 11.6042 2.91708 11.4625 3.05875C11.3208 3.20042 11.25 3.37958 11.25 3.59625C11.25 3.81292 11.3208 3.99208 11.4625 4.13375C11.6042 4.27542 11.7833 4.34625 12 4.34625Z"
              fill="#262626"
            />
          </svg>

          <span>Order</span>
        </NavLink>
        <NavLink
          id="nav-invoice"
          to="/customer/invoice"
          className={clsx(
            "sidebar-item",
            selectedMenu === "invoice" && "sidebar-selected"
          )}
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="24"
          >
            <path d="M309.231-300h40v-180h-40v180Zm301.538 0h40v-380h-40v380ZM460-300h40v-100h-40v100Zm0-180h40v-80h-40v80ZM224.615-160Q197-160 178.5-178.5 160-197 160-224.615v-510.77Q160-763 178.5-781.5 197-800 224.615-800h510.77Q763-800 781.5-781.5 800-763 800-735.385v510.77Q800-197 781.5-178.5 763-160 735.385-160h-510.77Zm0-40h510.77q9.23 0 16.923-7.692Q760-215.385 760-224.615v-510.77q0-9.23-7.692-16.923Q744.615-760 735.385-760h-510.77q-9.23 0-16.923 7.692Q200-744.615 200-735.385v510.77q0 9.23 7.692 16.923Q215.385-200 224.615-200ZM200-760v560-560Z" />
          </svg>
          <span>Invoice</span>
        </NavLink>
      </div>
    </nav>
  );
};

export default CustomerSidebar;
